import { useEffect, useState } from "react";

import { ROLES, USER_STATUSES, User } from "models";
import { useUserUpdate } from "modules/Users/service";
import { validateEmail } from "util/common";

type EditUserFormProps = {
  isOpen: boolean;
  onClose: () => void;
  user: User;
};

export const useEditUser = ({ isOpen, onClose, user }: EditUserFormProps) => {
  const { mutateAsync: updateUserMutation, isPending } = useUserUpdate();

  const [role, setRole] = useState<ROLES | null>(user.role);
  const [email, setEmail] = useState(user.email);
  const [status, setStatus] = useState(user.status === USER_STATUSES.Active ? true : false);

  const [formSubmitted, setFormSubmitted] = useState(false);

  const resetState = () => {
    setRole(user.role);
    setEmail(user.email);
    setStatus(user.status === USER_STATUSES.Active ? true : false);
    setFormSubmitted(false);
  };

  const isMissingValue = () => !role || !email;
  const handleEmailChange = (evt: React.ChangeEvent<HTMLInputElement>) => setEmail(evt.target.value);
  const handleUserStatusChange = (status: boolean) => setStatus(status);

  const handleUpdateUser = () => {
    setFormSubmitted(true);
    if (!role || !email || !validateEmail(email)) return;

    updateUserMutation({ user: { id: user.id, email, role, status: status ? USER_STATUSES.Active : USER_STATUSES.Inactive } });
    setFormSubmitted(false);
    onClose();
  };

  useEffect(() => {
    if (isOpen) resetState();
  }, [isOpen]);

  return {
    role,
    setRole,
    email,
    setEmail,
    status,
    setStatus,
    formSubmitted,
    isFormSubmitting: isPending,
    isMissingValue,
    handleEmailChange,
    handleUserStatusChange,
    handleUpdateUser
  };
};
